
function phone_validated(val, mycallback) {
    val = val.replace("+","");
    const today =  Date.now();
    let data = JSON.stringify({
        phone: val,
        randDate:today,
        "apiRandKey": apiRandKey
    });

    sessionStorage.setItem("tempNumber", val);
  
    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();

    const xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {

        if (this.readyState == 4 && this.status == 200) {

            console.log('valid ---- ' + this.responseText);
            $("#contact_number_h").val(this.responseText);
            $("#contact_number_h2").val(val);
          
            $("#OTP_pop_BOX").show();
            $(".template-register").addClass("active");
            $("#overlay").addClass("otpParent");
            timecount();
        }
    };

    xmlhttp.open("POST", cryptedMobileValidate, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
  
    xmlhttp.send(JSON.stringify({
      "data":encrypted
    }));

}


function phone_validated(val,mycallback){
    val = val.replace("+","");
    const today =  Date.now();
    let data = JSON.stringify({
        phone: val,
        randDate:today,
        "apiRandKey": apiRandKey
    });

    sessionStorage.setItem("tempNumber", val);

    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();

    const xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {

        if (this.readyState == 4 && this.status == 200) {

            console.log('valid ---- ' + this.responseText);
            $("#contact_number_h").val(this.responseText);
            $("#contact_number_h2").val(val);
          
            $("#OTP_pop_BOX").show();
            $(".template-register").addClass("active");
            $("#overlay").addClass("otpParent");
            timecount();
        }
    };

    xmlhttp.open("POST", cryptedMobileValidate, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
  
    xmlhttp.send(JSON.stringify({
      "data":encrypted
    }));
}
    
    
function opt_validated(otp, verifyID, email, mobile) {
    const today =  Date.now();
    mobile = sessionStorage.getItem("tempNumber");
    let data = JSON.stringify({
        phone: mobile,
        otp: otp,
        randDate:today,
        "apiRandKey": apiRandKey
    });;

    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
  
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.withCredentials = false;
  
    xmlhttp.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            console.log(this.responseText);
            let decrypted = CryptoJS.AES.decrypt(this.responseText, key, {
                iv: iv
            }).toString(CryptoJS.enc.Utf8);
            decrypted = JSON.parse(decrypted);
            console.log("decrypted",decrypted);
            console.log("decrypted", decrypted.otp);
            
            // FOR OTP GATEWAY FAIL AND CONTINUE THE CHECKING. REMOVE THIS WHEN SMS GATEWAY UP | START
            Register_updated_email(email);
            return;
            // FOR OTP GATEWAY FAIL AND CONTINUE THE CHECKING. REMOVE THIS WHEN SMS GATEWAY UP | END
            if(decrypted.otp != "error") {
              Register_updated_email(email);
            }
        }
    });

    xmlhttp.open("POST", cryptedOtpValidate, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
    xmlhttp.send(JSON.stringify({
      "data": encrypted
    }));

}



async function ecomSendOtp (phone) {
  phone = phone.replace("+","");
  const today =  Date.now();
  let data = JSON.stringify({
      phone: phone,
      randDate:today,
      "apiRandKey": apiRandKey
  });

  sessionStorage.setItem("tempNumber", phone);

  let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
  key = CryptoJS.enc.Utf8.parse(key);
  let iv = "O_1ltX'0Po>/hA*v";
  iv = CryptoJS.enc.Utf8.parse(iv);

  let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();

  try {
    const response = await fetch(cryptedMobileValidate, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ data: encrypted })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.text();
    console.log(result);
    return result;
  } catch (error) {
    console.log("Fetch error ecom send OTP:", error);
    throw error; // Re-throw the error to be caught by the outer try-catch
  }
}

async function ecomVerifyOtp(otp) {
  const today =  Date.now();
  mobile = sessionStorage.getItem("tempNumber");
  let data = JSON.stringify({
      phone: mobile,
      otp: otp,
      randDate:today,
      "apiRandKey": apiRandKey
  });;
  console.log(data);
  console.log(otp);
  
  let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
  key = CryptoJS.enc.Utf8.parse(key);
  let iv = "O_1ltX'0Po>/hA*v";
  iv = CryptoJS.enc.Utf8.parse(iv);

  let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
  
  const _fetch = await fetch(cryptedOtpValidate, {
    method: "POST",
    headers:{
      "Content-Type":"application/json"
    },
    body: JSON.stringify({
      data:encrypted
    })
  });
  
  let response = await _fetch.text();
  console.log("otp verify response", response);

  let decrypted = CryptoJS.AES.decrypt(response, key, {
      iv: iv
  }).toString(CryptoJS.enc.Utf8);

  decrypted = JSON.parse(decrypted);
  console.log("decrypted data",decrypted)
  return decrypted;
}

 function phone_validated(val){
   console.log(val);
    val = val.replace("+","");
    const today =  Date.now();
    let data = JSON.stringify({
        phone: val,
        randDate:today,
        "apiRandKey": apiRandKey
    });

    sessionStorage.setItem("tempNumber", val);
  
    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
   const xmlhttp = new XMLHttpRequest();
   xmlhttp.onreadystatechange = function() {
     
    if (this.readyState == 4 && this.status == 200) {
    
     console.log('valid ---- '+this.responseText);  
        $("#contact_number_h").val(this.responseText);
        $("#contact_number_h2").val(val);

      $(".otp-resetbtn").hide();
       $(".otp-time").show();
        $(".otp_form").show();
        $("#time_count").text('120');
        $("#otp_txt").val("");
        $(".otp-resetbtn").prop("disabled",true);
        $(".validatedBtn2").prop("disabled",false);
        $("#OTP_pop_BOX").show();
        $(".template-register").addClass("active");
        $("#overlay").addClass("otpParent");
        timecount();
     }
  };

   // xmlhttp.open("POST", "https://dd0aa4687572.ngrok.io/ustore/Phone_validate.php", true);
   xmlhttp.open("POST", cryptedMobileValidate, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
    xmlhttp.send(JSON.stringify({
      "data": encrypted
    }));
}  
  
  function opt_validated2(otp,verifyID,email){
       const today =  Date.now();
    mobile = sessionStorage.getItem("tempNumber");
    let data = JSON.stringify({
        phone: mobile,
        otp: otp,
        randDate:today,
        "apiRandKey": apiRandKey
    });;

    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
    
   const  xmlhttp = new XMLHttpRequest();
   xmlhttp.onreadystatechange = function() {

      if (this.readyState == 4 && this.status == 200) {
        console.log(this.responseText);
        let decrypted = CryptoJS.AES.decrypt(this.responseText, key, {
            iv: iv
        }).toString(CryptoJS.enc.Utf8);
        decrypted = JSON.parse(decrypted);
        
        if(decrypted.otp != "error"){

          try {
            phoneVerified = true;
          } catch(e){
            
          }
        
            $("#OTP_pop_BOX").hide();
            $(".otp_incorrect_alert").hide();
            updated_profile();
        }else{
            $(".otp_incorrect_alert").show();
            $(".validatedBtn2").prop("disabled",false);
        }            
        
       }
  };
    
  xmlhttp.open("POST", cryptedOtpValidate, true);
  xmlhttp.setRequestHeader("Content-type", "application/json");
  xmlhttp.send(JSON.stringify({
    "data": encrypted
  }));
}

  
function phone_validated_b2b_form(val,mycallback){
  console.log("phone_validated_b2b_form")
  val = val.replace("+","");
    const today =  Date.now();
    let data = JSON.stringify({
        phone: val,
        randDate:today,
        "apiRandKey": apiRandKey
    });

    sessionStorage.setItem("tempNumber", val);
  
    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();

    const xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {

        if (this.readyState == 4 && this.status == 200) {

            console.log('valid ---- ' + this.responseText);
            $("#contact_number_h").val(this.responseText);
            $("#contact_number_h2").val(val);
          
            $("#OTP_pop_BOX").show();
            $(".template-register").addClass("active");
            $("#overlay").addClass("otpParent");
            timecount();
        }
    };

    xmlhttp.open("POST", cryptedMobileValidate, true);
    xmlhttp.setRequestHeader("Content-type", "application/json");
  
    xmlhttp.send(JSON.stringify({
      "data":encrypted
    }));

}

function opt_validated2(otp,verifyID,email){
  const today =  Date.now();
    mobile = sessionStorage.getItem("tempNumber");
    let data = JSON.stringify({
        phone: mobile,
        otp: otp,
        randDate:today,
        "apiRandKey": apiRandKey
    });;

    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
  
  const  xmlhttp = new XMLHttpRequest();
  
  xmlhttp.onreadystatechange = function() {

    if (this.readyState == 4 && this.status == 200) {

      let decrypted = CryptoJS.AES.decrypt(this.responseText, key, {
          iv: iv
      }).toString(CryptoJS.enc.Utf8);
      decrypted = JSON.parse(decrypted);
      
      if(decrypted.otp != "error") {
         $("#OTP_pop_BOX").hide();
        $(".otp_incorrect_alert").hide();
        $(".phone_validatedb2b").text('Validated');

        try {
            phoneVerified = true;
          } catch(e){
            
          }
        
        const imIn = document.querySelector(`#im-in`).dataset.template;
        if(imIn == "customers/account") {
          updated_profile();
        }
        
        $('.b2b_next').prop("disabled",false);
      }else{
         $(".otp_incorrect_alert").show();
        $(".validatedBtn2").prop("disabled",false);
      }
    }
  };

  xmlhttp.open("POST", cryptedOtpValidate, true);
  xmlhttp.setRequestHeader("Content-type", "application/json");
  xmlhttp.send(JSON.stringify({
    "data": encrypted
  }));
}

function encriptGivenData(data) {
    if (typeof(data) !== "string") return false;

    let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = "O_1ltX'0Po>/hA*v";
    iv = CryptoJS.enc.Utf8.parse(iv);

    let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
    return encrypted;
}

